import { FC } from "react";
import { Box } from "@mui/material";
import { NotificationDto } from "@/modules/notification-center/dtos";
import { getNotificationTimestamps } from "@/modules/notification-center/utility";

import { NotificationBody } from "@/modules/notification-center/components/notification/notification-fragments/notification-body";
import { NotificationCard } from "@/modules/notification-center/components/notification/notification-fragments/notification-card";
import { NotificationTitleBar } from "@/modules/notification-center/components/notification/notification-fragments/notification-title-bar";
import { NotificationTimestamp } from "@/modules/notification-center/components/notification/notification-fragments/notification-timestamp";
import { NotificationIndicator } from "@/modules/notification-center/components/notification/notification-fragments/notification-indicator";
import { NotificationLinkAction } from "@/modules/notification-center/components/notification/notification-fragments/notification-link-action";

interface DefaultNotificationTemplateProps {
  notification: NotificationDto;
  linkLabel?: string;
}

export const DefaultNotificationTemplate: FC<
  DefaultNotificationTemplateProps
> = ({ notification, linkLabel }) => {
  const { relativeTime, absoluteTime } = getNotificationTimestamps(
    notification?.createdAt
  );

  return (
    <NotificationCard notification={notification}>
      <Box
        sx={{
          padding: "16px",
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <NotificationIndicator isRead={notification?.read ? true : false} />

        <Box display="flex" flexDirection="column" gap={1}>
          <NotificationTitleBar
            title={notification?.title || notification?.SystemTemplate?.name}
            relativeTime={relativeTime}
          />

          <NotificationBody body={notification?.body} />

          <NotificationTimestamp absoluteTime={absoluteTime} />

          {notification?.link && (
            <NotificationLinkAction
              notification={notification}
              label={linkLabel ?? "View lead"}
            />
          )}
        </Box>
      </Box>
    </NotificationCard>
  );
};
